import axiosHttp from "services/axiosHttp";
import moment from "moment";
import PermissionManager from "utils/class/PermissionManager";
import { USER } from "constants/AuthConstant";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchPaymentRequests = createAsyncThunk("fetchPaymentRequests", async ({ filters, page, limit }, { rejectWithValue }) => {
	try {
		const user = PermissionManager.getItem(USER)?.user;
		const channel_id = user?.user_channel?.[0]?.channel_uuid;
		if (!channel_id) throw new Error("Channel ID not found");

		const [start_date, end_date] = filters?.range?.length === 2 ? filters.range.map((date) => moment(date.$d).format("YYYY-MM-DD")) : ["", ""];

		const params = new URLSearchParams({
			page,
			limit,
			keyword: filters?.keyword || "",
			status_id: filters?.status_id || "",
			secondary_payment_method_id: filters?.secondary_payment_method_id || "",
			rep_id: filters?.rep_id || "",
			is_dispute: filters?.dispute_partial_filter?.includes("dispute") ? true : "",
			is_partial: filters?.dispute_partial_filter?.includes("partial") ? true : "",
			start_date: start_date,
			end_date: end_date,
		});

		const response = await axiosHttp.get(`channel/${channel_id}/payment/request?${params}`);

		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong");
	}
});

const PaymentRequestsSlice = createSlice({
	name: "PaymentRequestsSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
		paymentMethodCounts: [],
	},

	extraReducers: (builder) => {
		builder.addCase(fetchPaymentRequests.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchPaymentRequests.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload.paymentRequests;
			state.page = action.payload.page;
			state.total = action.payload.total;
			state.paymentMethodCounts = action.payload.paymentMethodCounts || [];
			state.disputeCount = action.payload.disputeCount || [];
		});

		builder.addCase(fetchPaymentRequests.rejected, (state, action) => {
			state.isLoading = false;

			if (action.error.message) {
				state.error = action.error.message;
			} else {
				state.error = "Unknown error occurred";
			}
		});
	},
});

export default PaymentRequestsSlice.reducer;
